var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSectionSoftware3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1669_2938",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 80
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "66092429a6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H77.4194V80H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1669_2938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.3041 0.15457L46.4183 0L46.1092 27.2849L69.3977 14.3369L77.4174 25.8961L52.8968 39.9238L77.4174 53.3333L69.5523 66.5905L45.9568 51.1761L45.8023 80H31.4586L32.2292 51.0215L7.55405 66.8974L0.152617 52.8719L25.5984 39.7693L-0.00195312 25.5892L8.01776 12.948L31.9223 27.7464L31.3041 0.15457Z",
    fill: "#D7D3F7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionSoftware3);
export default __webpack_public_path__ + "static/media/icon-section-software-3.c107c0c10cea64797efee4607f7ecfe3b7b03054e34c377df644e009d4ba2270.svg";
export { ForwardRef as ReactComponent };